import React from "react";
import Modal from "../../Components/Modal";
import { motion } from "framer-motion";
import { HiOutlineCheck } from "react-icons/hi2";
import Button from "../../Components/Button";
import { emptyOrderState } from "../../context/AppContext";

const Index = ({ closeModal, t, setCurrentOrderList, navigate }) => (
  <Modal
    onClose={closeModal}
    isCloseIcon={false}
    isBottomButton={false}
    bottomComponent={
      <div className="flex flex-col gap-2 sticky bottom-0 z-10 bg-background shadow-sheet px-4 pb-5 pt-3">
        <Button
          size="lg"
          fullWidth
          onClick={() => {
            navigate("/");
            setCurrentOrderList(emptyOrderState());
          }}
        >
          {t("Back to Menu")}
        </Button>
        <Button
          variant="secondary"
          fullWidth
          onClick={() => {
            closeModal();
            setCurrentOrderList(emptyOrderState());
          }}
        >
          {t("Order History")}
        </Button>
      </div>
    }
    isHeader={false}
  >
    <div className="flex flex-col gap-6 justify-center items-center h-full px-6">
      <motion.div
        initial={{ scale: 0, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ type: "spring", stiffness: 200, damping: 15 }}
        className="w-20 h-20 rounded-full bg-success-50 text-success flex items-center justify-center"
      >
        <HiOutlineCheck size={40} />
      </motion.div>
      <motion.div
        initial={{ y: 20, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ delay: 0.3 }}
        className="flex flex-col gap-2 justify-center items-center"
      >
        <h2 className="text-xl font-bold text-dark text-center">
          {t("submitTitle")}
        </h2>
        <p className="text-center text-sm text-muted max-w-xs">
          {t("submitDescription")}
        </p>
      </motion.div>
    </div>
  </Modal>
);

export default Index;
